import * as Redux from "redux";
import storage from "redux-persist/lib/storage";

import { FilterParams } from "src/core/shared/api";
import { ProductActions } from "src/core/products/store/products.actions";
import * as AT from "src/core/products/store/products.constants";
import {
  IProduct,
  IProductCategory
} from "src/core/products/api/products.api";

import { GetProductResponse } from "../api/products.api";

export type ProductFilterParams = FilterParams<Omit<IProduct, "prices" | "promotionalTags" > & { prices: { priceCodeId: number }; promotionalTags?: number[];}>;
export interface IProductsStore {
  product: GetProductResponse | null;
  priceLists: {
    priceListId: null | number;
    effectiveDate: null | string;
  };
}

export interface IProductCategories {
  categories: IProductCategory[];
  category: IProductCategory | null;
}

const initialState: IProductsStore = {
  product: null,
  priceLists: {
    priceListId: null,
    effectiveDate: null
  }
};

export const productsReducer: Redux.Reducer<IProductsStore> = (state: IProductsStore = initialState, action: ProductActions): IProductsStore => {
  switch (action.type) {
    case AT.SET_PRODUCT:
      return {
        ...state,
        product: action.product
      };

    case AT.SET_PRICE_LIST_ID:
      return {
        ...state,
        priceLists: {
          ...state.priceLists,
          priceListId: action.priceListId
        }
      };

    case AT.SET_EFFECTIVE_DATE:
      return {
        ...state,
        priceLists: {
          ...state.priceLists,
          effectiveDate: action.effectiveDate
        }
      };

    case AT.PURGE_PRODUCTS:
      return initialState;
    default:
      return state;
  }
};

// config for persisting within this reducer
export const productsPersistConfig = {
  key: "products",
  storage
};
